export const metaTags = {
  metaTitle: "404 - Not Found",
  metaDescription: "",
  image: "",
};
